import type { TooltipProps } from "antd";

import { Tooltip as AntdTooltip } from "antd";

// Avoid Ant Design Tooltip error `Warning: findDOMNode is deprecated and will be removed in the next major release.`
// https://ant.design/components/tooltip#why-does-the-warning-finddomnode-is-deprecated-sometimes-appear-in-strict-mode
export const Tooltip = ({ children, ...props }: TooltipProps) => {
  return (
    <AntdTooltip {...props}>
      <div>{children}</div>
    </AntdTooltip>
  );
};
